var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMontage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 61,
    viewBox: "0 0 55 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0306 60.834C53.6705 60.834 55 59.5002 55 57.8548L55 2.55833C55 1.606 54.2305 0.833984 53.2813 0.833984C30.8449 0.833986 12.6566 19.0816 12.6566 41.5912L12.6566 58.3985C12.6566 59.7436 13.7434 60.834 15.0841 60.834L52.0306 60.834Z",
    fill: "url(#paint0_linear_13843_92089)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4484 60.834C41.6167 60.834 42.5637 59.8838 42.5637 58.7118L42.5637 42.0262C42.5637 19.2764 24.1813 0.833998 1.50547 0.834C0.67402 0.834 -1.77497e-07 1.51022 0 2.34438L1.18118e-05 57.8549C1.21619e-05 59.5002 1.32948 60.834 2.96945 60.834L40.4484 60.834Z",
    fill: "url(#paint1_linear_13843_92089)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13843_92089",
    x1: 35.3741,
    y1: -5.80778,
    x2: 16.971,
    y2: 10.0978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13843_92089",
    x1: 51.2145,
    y1: 32.1053,
    x2: 8.01205,
    y2: 30.5496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.429975,
    stopColor: "#92C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92E4F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontage);
export default __webpack_public_path__ + "static/media/montage.f4053fde5a0f04ad91e244fa426f8dee.svg";
export { ForwardRef as ReactComponent };